import gql from 'graphql-tag';

export default gql`
  mutation EditTheater(
    $id: ID!
    $name: String
    $publish: Boolean
    $address: String
    $city: String
    $country: String
    $biography: String
    $userId: ID
    $website: String
    $director: String
    $facebook: String
    $contact: String
    $telephone: String
    $email: String
    $plan: String
    $role: String
    $type: String
    $features: [TheaterFeatureInput]
    $images: [TheaterImageInput]
  ) {
    editTheater(
      id: $id
      facebook: $facebook
      publish: $publish
      name: $name
      address: $address
      city: $city
      country: $country
      biography: $biography
      userId: $userId
      plan: $plan
      website: $website
      director: $director
      contact: $contact
      telephone: $telephone
      email: $email
      role: $role
      type: $type
      features: $features
      images: $images
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/EditTheater.js